import React from 'react';

export function IllustrationWebsiteEditing(props) {
  return (
    <svg {...props} viewBox="0 0 909 777">
      <g fill="none" fillRule="evenodd">
        <path
          d="M316.45 105.14C922.63 227.68 882.47-136.5 989.5 38.5c102.56 167.73 108.66 861.47-142.03 700-250.7-161.48-244.11 1.92-481.69 37.29-248.46 37-655.5-793.2-49.32-670.66z"
          fill="#9869E4"
          fillOpacity=".2"
        />
        <g transform="translate(52 208)">
          <path
            d="M416.42 43.75a5.17 5.17 0 0 0 .49-1.56c.04-.26.07-.52.08-.78v-.87a6 6 0 0 0-.71-2.32 4.3 4.3 0 0 0-1.66-1.67 28.07 28.07 0 0 0 1.8-10.38c-.26-9.78-5-18.57-15.46-18.57-9 0-16.32 8.3-16.32 18.53 0 .44 0 .86.06 1.29a6.07 6.07 0 0 0-5.06 2.76 7.61 7.61 0 0 0-1.32 3.55c-.42 3.94 2 7.52 5.52 8l-.69 6.48-.2 1.84-.78 7.36-.73 6.84c-.19 2.2 10.7 8.64 12.35 9.2 6.23 2.09 6.78-5.66 8.09-10.37 1.71-6.16 5.22-11.69 8.36-17.33l.46.25h.09l.42.15h.13a3 3 0 0 0 .43.09h.15a6 6 0 0 0 1.45-.08h.13c.24-.06.47-.13.7-.22l.13-.06c.22-.1.43-.2.62-.34l.08-.06a3.75 3.75 0 0 0 .98-.99l.07-.1c.13-.2.24-.42.34-.64z"
            fill="#9978FF"
            fillRule="nonzero"
          />
          <g opacity=".2" transform="translate(0 95)">
            <rect
              height="340.52"
              width="556.36"
              rx="7"
              stroke="#6A25D6"
              strokeWidth="2"
              x="16"
              y="14.38"
            />
          </g>
          <path
            d="M572.36 150.89H16v-34.51a7 7 0 0 1 7-7h542.36a7 7 0 0 1 7 7v34.51z"
            fill="#9978FF"
            fillRule="nonzero"
          />
          <rect
            height="84.27"
            width="80.27"
            fill="#6A25D6"
            fillRule="nonzero"
            rx="4"
            x="353.62"
            y="274.48"
          />
          <path
            d="M429.9 173.93a2 2 0 0 1 2 2v76.28a2 2 0 0 1-2 2h-72.28a2 2 0 0 1-2-2v-76.28c0-1.1.9-2 2-2h72.28zm0-2h-72.28a4 4 0 0 0-4 4v76.28a4 4 0 0 0 4 4h72.28a4 4 0 0 0 4-4v-76.28a4 4 0 0 0-4-4z"
            fill="#9978FF"
            fillRule="nonzero"
            opacity=".5"
          />
          <rect
            height="37.65"
            width="282.65"
            fill="#9978FF"
            fillRule="nonzero"
            rx="4"
            x="242.03"
            y="375.98"
          />
          <rect
            height="186.2"
            width="71.29"
            fill="#9978FF"
            fillRule="nonzero"
            rx="4"
            transform="rotate(180 486.05 265.66)"
            x="450.4"
            y="172.56"
          />
          <path
            d="M482.37 96.61c-8-16.77-27.08-30.07-45.08-34.4-7.29-1.75-14.84-2.52-22.18-1.21s-14.41 5-19 10.83c-8.4-8.5-20.73-12.66-32.67-12-11.94.66-23.44 6.02-32.44 13.89-5.16 4.51-9.73 10.17-11 16.9-1.27 6.73 2.42 16.06 8.71 18.76 0 0 103.12.45 104 0 0 0-.38-9.36 3.11-11.56 1.27-.8 2.91-.64 4.39-.39 8.87 1.54 16.34 7.2 22.35 14.32 4.29 5.08 5.74 12.07 5.34 18.7-.4 6.63-1.46 15-3.51 21.36l5.11 1.94c3.4-6.85 7.18-14.92 11.14-21.47 7.51-12.35 6.96-24.74 1.73-35.67z"
            fill="#46204F"
            fillRule="nonzero"
          />
          <circle
            cx="503.04"
            cy="314.9"
            fill="#6A25D6"
            fillRule="nonzero"
            r="19.25"
          />
          <circle
            cx="486.04"
            cy="265.66"
            fill="#FFF"
            fillRule="nonzero"
            r="19.25"
          />
          <circle
            cx="486.04"
            cy="210.42"
            fill="#6A25D6"
            fillRule="nonzero"
            r="19.25"
          />
          <path
            d="M267.93 393.66v-4.2a5.03 5.03 0 0 0-10.06 0v4.2h-2.23v11.51h14.52v-11.51h-2.23zm-8.39 0v-4.2a3.36 3.36 0 1 1 6.72 0v4.2h-6.72z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <path
            d="M264.56 398.31a1.66 1.66 0 1 0-2.5 1.4v2.47h1.68v-2.47c.5-.29.81-.82.82-1.4zM506 321.34h4.74a3.37 3.37 0 1 0 0-6.74h-.07c.04-.23.06-.47.07-.7a7.43 7.43 0 0 0-14.57-2 4.76 4.76 0 0 0 .5 9.49H506v-.05zm-20-111.4a2.9 2.9 0 0 1-2.9-2.9v-1.69a2.89 2.89 0 1 1 5.79 0V207a2.89 2.89 0 0 1-2.89 2.94zm-4.36 2.13h8.79a3.1 3.1 0 0 1 3.1 3.1v3.2h-15v-3.2a3.1 3.1 0 0 1 3.11-3.1z"
            fill="#FFF"
            fillRule="nonzero"
          />
          <path
            d="M484.8 261.53l-1.78-2.23h-5.19v12.71h16.42v-10.48z"
            fill="#9978FF"
            fillRule="nonzero"
          />
          <rect
            height="3.44"
            width="217.87"
            fill="#FFF"
            fillRule="nonzero"
            rx="1.72"
            x="290.41"
            y="393.08"
          />
          <circle
            cx="38.07"
            cy="130.22"
            fill="#FFF"
            fillRule="nonzero"
            r="5.48"
          />
          <circle
            cx="57.26"
            cy="130.22"
            fill="#FFF"
            fillRule="nonzero"
            r="5.48"
          />
          <circle
            cx="76.45"
            cy="130.22"
            fill="#FFF"
            fillRule="nonzero"
            r="5.48"
          />
          <path
            d="M666.48 470.39c.09 4.44.8 8.84 2.13 13.08 1.46 4.42 6.09 11.24 11.28 7 1.25-1 3 .83 1.78 1.86-4 3.26-9.25 2-12.41-2-4.24-5.3-5.07-13.44-5.3-20-.06-1.67 2.46-1.6 2.52.07v-.01zm-60.79 15.09a5.76 5.76 0 0 1-3.4-1.5 1.46 1.46 0 1 1 2-2.14 3.1 3.1 0 0 0 2.29.75 5.74 5.74 0 0 0 3.8-1.88c5.62-6.39 3.31-16.49 3.28-16.59a1.46 1.46 0 0 1 2.84-.68c.11.47 2.7 11.65-3.93 19.19a8.66 8.66 0 0 1-5.84 2.87 7 7 0 0 1-1.04-.02z"
            fill="#46204F"
            fillRule="nonzero"
          />
          <path
            d="M616.48 464.14c.21-14.24 1.88-28.48 2.09-42.72.14-9.78.34-19.56.84-29.33.43-8.46 0-16.44 3-24.45-4.8-2-10.75-2.46-15.82-3.4-1.52-.29-6.52-2.14-8-1.34-9.13 5.13 4.19 48.35 5.71 56 .67 3.4 7 45.57 9.06 45.72a5.57 5.57 0 0 0 3.12-.48zm47.86-87.36a36.55 36.55 0 0 1 3.28-9.41c-9.13.87-18.31 1.05-27.47.55a22 22 0 0 0-.12 12.77l23.74 93.84 3 .63c-.63-13-.31-25.93-.93-38.89-.5-10.36-1.05-20.71-1.5-31.06-.42-10.06-1.88-19.29 0-28.43z"
            fill="#FFF"
            fillRule="nonzero"
          />
          <path
            d="M664.47 282.82c-.87-2-1.78-4.05-2.81-6-28.47 9.05-63.16-12.28-62.93 26.84.07 11.88-3.57 44.37-6.81 55.79-1.62 5.69-4.61 11-5.48 16.85-4.3 29 52.08 20.56 67.62 16.79 5.3-1.29 11.93-3 15.41-7.42 4.2-5.37 2.88-13.07 3.48-19.4.68-7.23 1.18-14.47 1.34-21.73.29-13.15.5-28.35-3.43-41.05l-6.39-20.67z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <path d="M612.62 210.69l-11.78 2.37 11.78-2.37z" />
          <path
            d="M382.24 66.56l1.58 14.3a.76.76 0 0 0 1.28.53c2.43-2.45 5.18-6.45 8.2-8.09.84-.45-.2-.49 1.18.07 1.03.48 2.03 1.02 3 1.62 1.61.89 3.22 1.79 4.81 2.7a.76.76 0 0 0 1.1-.45l1.76-12.31c.13-.94-1.31-1.35-1.45-.39l-1.7 12.3 1.1-.45c-2-1.12-3.92-2.23-5.91-3.3-1.11-.59-2.76-1.92-4.09-1.56-1.49.4-3.38 3.14-4.43 4.18a670.8 670.8 0 0 0-4.62 4.62l1.28.53-1.58-14.3c-.11-1-1.61-1-1.5 0h-.01zm-30.16 22.26c-6.66 15.49 16.15 20.51 26.52 21.33 1.29.1 1.28-1.9 0-2-8.54-.68-30.74-4.49-24.79-18.32.5-1.17-1.22-2.19-1.73-1v-.01z"
            fill="#D8C4F7"
            fillRule="nonzero"
          />
          <path
            d="M467.81 149.52c-1.5-.66-3.68.48-3 2.46 0 0 .43-.31-.09.16l-.37.35c-.49.42-1 .76-1.52 1.19a4.74 4.74 0 0 0-1.77 3.63 2.2 2.2 0 0 0 1.59 2.09c3.88 1.06 5.85-4.08 7.43-6.69 1.03-1.71-.71-3.38-2.27-3.19zm-284.57 47.16c0-6 2.39-11 3.47-16.81a49.26 49.26 0 0 0 .27-17.42c-.8-4.46-2.31-8.23-6-11.26-4.26-3.52-11.69-3.32-15.71.13a19.77 19.77 0 0 0-7 14.39c0 1.22-.06 2.45-.06 3.68-4.95-.13-6.09 7.78-.77 8.7.55.1 1.11.1 1.66 0 .18.72.4 1.42.66 2.11 1.61 4.25 5.69 7.51 6.16 12.18.4 4.07-.45 8.62-1.1 12.68-.5 3.18 4.56 23 8.54 23.43 2.3.28 9.79-20.91 9.79-20.91s.11-6.58.09-10.9z"
            fill="#9978FF"
            fillRule="nonzero"
          />
          <path
            style={{ mixBlendMode: 'multiply' }}
            d="M181.08 175s-.9-6.74-1.29-9.81c-.11-.88-1.69-.78-1.58.1.36 2.84 1.07 9.14 1.07 9.14a36.65 36.65 0 0 1-4-.65.69.69 0 1 0-.23 1.35c1.7.37 3.42.63 5.16.77.64.02 1.06-.39.87-.9z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <path
            style={{ mixBlendMode: 'multiply' }}
            d="M194.08 145.65a6.08 6.08 0 0 0-4.86-2.23 7.1 7.1 0 0 1-2.84-.13 6.34 6.34 0 0 1-2-1.77c-3.66-3.91-15.84-3.29-20.1-.54-1.34.86-2.18 2.3-3.26 3.49-2.34 2.6-5.55 1.91-7.2 5.5a8.53 8.53 0 0 0 1.8 9.83c-.42-.45-.44 1.58-.43 1.64.25 1.94 2.31 6.24 3.27 7.89.71 1.22 1.42 2.33 3 1.81 2.31-.75-2.06-5.45-1.39-7.45.83-2.49 10.31-9.74 21.58-7.2 4.22.95 7.7 4.66 11.9.79 3.15-2.87 3.15-8.5.53-11.63z"
            fill="#46204F"
            fillRule="nonzero"
          />
          <path
            d="M132.39 500.27c-3.39 0-7-1.85-8.08-5a1.37 1.37 0 0 1 1.27-1.77h.18c.57-.04 1.1.3 1.32.82.69 1.87 3.25 3 5.51 3a9.1 9.1 0 0 0 6.55-3 7.51 7.51 0 0 0 1.78-5.63c-.08-.67.3-1.3.94-1.52l.14-.05a1.38 1.38 0 0 1 1.8 1.1c.32 2.92-.58 5.85-2.48 8.09a11.85 11.85 0 0 1-8.64 4l-.29-.04zm91 2.27a13 13 0 0 1-3.32-.44c-6.69-1.78-11.39-9.28-10.53-16.3a1.38 1.38 0 0 1 1.72-1.15h.14c.67.18 1.1.83 1 1.51-.7 5.59 3.05 11.58 8.38 13 2.5.68 5.18.32 7.41-1a1.39 1.39 0 0 1 1.82.28l.14.17a1.38 1.38 0 0 1-.3 2 12.08 12.08 0 0 1-6.46 1.93z"
            fill="#46204F"
            fillRule="nonzero"
          />
          <path
            d="M212.92 308.53c3.09 60.34 1.94 119.47 0 179.82h-5.26L182.22 335.5l-11.4.44s-.74 9.37-1.08 13.14c-2.52 28.53-8.58 57.29-14.39 85.29-.76 3.67-10 54-11.52 54h-3.21c-.77-8.9-7.92-178.82-1.59-178.82l73.89-1.02z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <path
            d="M211.76 238.16c38.38 12.67 79.23-9.35 79.23-9.35l-8-9a130.43 130.43 0 0 1-37.4-.93 432.87 432.87 0 0 1-24.73-5C187.74 206 135.21 190.45 131 240c-1.85 21.87-1.23 59 1.52 80.77.01.9.31 1.76.86 2.46.54.42 1.23.62 1.91.56 24.6.82 50.09-1.07 74.69-1.53 1.82 0 4-.28 4.88-2.14.46-1.23.6-2.56.38-3.86-.87-11.54-3.54-36.15-4.53-47.67-.02-10.16.61-20.29 1.05-30.43z"
            fill="#18E8E3"
            fillRule="nonzero"
          />
          <path
            d="M615.06 324.92a1.4 1.4 0 0 1-1-.41 1.42 1.42 0 0 1 0-2l3.55-3.55a1.41 1.41 0 1 1 2 2l-3.56 3.56c-.26.26-.62.4-.99.4zm2.2 16.9A1.43 1.43 0 0 1 616 341l-2.77-5.72a1.42 1.42 0 0 1 2.55-1.24l2.77 5.73a1.4 1.4 0 0 1-.66 1.88c-.2.1-.4.16-.63.17zm13.33-9.82c-.41 0-.8-.18-1.07-.5a1.41 1.41 0 0 1 .15-2l3.11-2.66a1.41 1.41 0 0 1 1.84 2.14l-3.11 2.67a1.4 1.4 0 0 1-.92.35zm2.25-12.86c-.44 0-.85-.2-1.12-.55l-2.72-3.51a1.42 1.42 0 1 1 2.24-1.73l2.72 3.51a1.41 1.41 0 0 1-.25 2c-.25.19-.56.28-.87.28zm-27.55 37.76a1.42 1.42 0 0 1-.58-2.71 13 13 0 0 0 4-2.79 1.41 1.41 0 1 1 2 2 15.81 15.81 0 0 1-4.89 3.4c-.17.07-.35.1-.53.1zm17.71 1.79a1.4 1.4 0 0 1-1.28-.8 7.54 7.54 0 0 0-2.17-2.71 1.41 1.41 0 1 1 1.74-2.23 10.3 10.3 0 0 1 3 3.73 1.4 1.4 0 0 1-1.29 2.01zm8.39-12.07a1.44 1.44 0 0 1-1.16-2.26 10 10 0 0 1 5.37-3.85 1.42 1.42 0 0 1 .79 2.72 7.16 7.16 0 0 0-3.84 2.75c-.26.4-.7.63-1.16.64zm15.72-17.28c-.54 0-1.04-.31-1.28-.8-.72-1.5-1.7-2.85-2.89-4a1.41 1.41 0 1 1 2-2 16.5 16.5 0 0 1 3.48 4.8c.34.7.04 1.55-.66 1.89-.2.08-.43.12-.65.11zm-.51-15.52c-.14 0-.27-.02-.4-.06a1.42 1.42 0 0 1-1-1.76 6.75 6.75 0 0 1 4.54-4.48 1.41 1.41 0 0 1 .77 2.72 3.86 3.86 0 0 0-2.6 2.56c-.17.59-.7 1-1.31 1.02zm15.52 8.46c-.44 0-.85-.2-1.12-.54l-3.12-4a1.41 1.41 0 1 1 2.22-1.74l3.13 4a1.41 1.41 0 0 1-.24 2c-.25.19-.56.28-.87.28zm-16.86 28.83a1.41 1.41 0 0 1-.73-2.62 30.9 30.9 0 0 0 6-4.65 1.42 1.42 0 0 1 2 2 33.32 33.32 0 0 1-6.52 5.06c-.22.14-.48.22-.75.21zm-7.26 12.1c-.5 0-.96-.26-1.21-.68l-2.68-4.44a1.41 1.41 0 1 1 2.42-1.46l2.68 4.43c.4.67.18 1.54-.48 1.95-.22.13-.47.2-.73.2zm-29.61 9.68a1.41 1.41 0 0 1-.87-2.53l4.77-3.71a1.41 1.41 0 0 1 2 .25 1.42 1.42 0 0 1-.24 2l-4.77 3.7c-.26.2-.57.3-.89.29zm22.7 4.86a1.42 1.42 0 0 1-1-.45l-5.77-6.22a1.42 1.42 0 0 1 2.08-1.93l5.77 6.23a1.41 1.41 0 0 1-1 2.37h-.08zm-29.44-33.36a1.41 1.41 0 0 1-1.07-2.34 14.12 14.12 0 0 1 4.12-3.24c.7-.35 1.55-.08 1.91.61.36.7.08 1.55-.61 1.91a11.26 11.26 0 0 0-3.29 2.58c-.27.3-.65.48-1.06.48zm66.4 12.43c-.47 0-.9-.23-1.17-.61l-3.61-5.29a1.41 1.41 0 0 1 2.33-1.6l3.62 5.29a1.43 1.43 0 0 1-.37 2c-.24.15-.52.22-.8.21zm-15.29 5.81a1.41 1.41 0 0 1-1.06-2.35l4.57-5.21a1.41 1.41 0 0 1 2.13 1.86l-4.57 5.22c-.27.3-.66.48-1.07.48zm-6.59 14.26c-.52 0-1-.28-1.24-.74a13.83 13.83 0 0 0-2.84-3.61 1.41 1.41 0 1 1 1.9-2.09 16.41 16.41 0 0 1 3.42 4.35 1.42 1.42 0 0 1-1.24 2.09zm11.55 1.8c-.44 0-.86-.2-1.12-.56a1.41 1.41 0 0 1 .26-2 44.62 44.62 0 0 1 6.44-4.09 1.41 1.41 0 0 1 1.31 2.5 41.29 41.29 0 0 0-6 3.84c-.25.2-.57.3-.89.31zm-35.32 8.46c-.68 0-1.27-.48-1.4-1.15a3.35 3.35 0 0 0-2.61-2.59 1.4 1.4 0 0 1-1.15-1.63c.13-.77.86-1.29 1.63-1.16a6.13 6.13 0 0 1 4.91 4.88 1.41 1.41 0 0 1-1.14 1.64 1.1 1.1 0 0 1-.24.01zm-23.72-1.25a1.41 1.41 0 0 1-.59-2.7 34.07 34.07 0 0 0 5.47-3.13 1.41 1.41 0 1 1 1.63 2.31 37.07 37.07 0 0 1-5.93 3.39 1.3 1.3 0 0 1-.58.13zm-1.42-9.43c-.5 0-.97-.27-1.22-.7l-2.61-4.47a1.41 1.41 0 1 1 2.44-1.43l2.61 4.47c.4.67.17 1.54-.5 1.94-.22.13-.47.2-.72.19zm10.2-59.07c-.5 0-.95-.26-1.21-.68a5.17 5.17 0 0 0-2.72-2.19 1.42 1.42 0 1 1 .92-2.68 7.9 7.9 0 0 1 4.22 3.41c.4.67.18 1.53-.48 1.94-.22.13-.47.2-.73.2zm58.16-10.2c-.5 0-.96-.26-1.21-.69l-2.15-3.59a1.41 1.41 0 0 1 2.43-1.45l2.14 3.59a1.41 1.41 0 0 1-1.21 2.14z"
            fill="#D8C4F7"
            fillRule="nonzero"
          />
          <path
            d="M16 150.89h82v299H23a7 7 0 0 1-7-7v-292z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <path
            d="M353.23 298.45c.22.77.33 1.57.33 2.37v12.63h50.79a6 6 0 0 0 6-6v-33.06h-57.12v24.06z"
            fill="#6A25D6"
            fillRule="nonzero"
            opacity=".4"
          />
          <path
            d="M188.75 165.82a5.11 5.11 0 0 0-6.48-.08 1 1 0 0 0-.12 1.42.93.93 0 0 0 1.33.15 3.14 3.14 0 0 1 4 0 .93.93 0 0 0 .93.17 1 1 0 0 0 .65-.78 1 1 0 0 0-.31-.88zm-15.1.93a6.72 6.72 0 0 0-5.74.82.88.88 0 0 0-.41.8c.03.38.26.73.6.9a.91.91 0 0 0 .92-.05 4.91 4.91 0 0 1 4.24-.55.84.84 0 0 0 1.08-.59 1.06 1.06 0 0 0-.69-1.33z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <path
            style={{ mixBlendMode: 'multiply' }}
            d="M180.53 180a4.4 4.4 0 0 0-.51-.05c-1 0-2.07 0-3.09-.1a23.15 23.15 0 0 1-4.23-.91 1 1 0 0 0-1.09.91c.05.46.34.86.76 1.06a10 10 0 0 0 7.86 1.14c.32-.06.63-.22.87-.44a1 1 0 0 0-.28-1.52 1.4 1.4 0 0 0-.29-.09z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <rect
            height="92.46"
            width="163.69"
            fill="#9978FF"
            fillRule="nonzero"
            rx="4"
            x="240.57"
            y="215.48"
          />
          <path
            d="M291 228.81a32.85 32.85 0 0 0-21.82 57.47A32.88 32.88 0 1 0 291 228.81z"
            fill="#FFF"
            fillRule="nonzero"
          />
          <g
            style={{ mixBlendMode: 'multiply' }}
            fill="#6A25D6"
            fillRule="nonzero"
            transform="translate(335 234)"
          >
            <rect height="3.44" width="51.15" rx="1.72" x=".58" y=".72" />
            <rect height="3.44" width="51.15" rx="1.72" x=".58" y="13.35" />
            <rect height="3.44" width="51.15" rx="1.72" x=".58" y="25.99" />
            <rect height="3.44" width="51.15" rx="1.72" x=".58" y="38.62" />
            <rect height="3.44" width="31.68" rx="1.72" x=".58" y="51.26" />
          </g>
          <path
            d="M179.26 233.61c11.09 30 72.15 26.32 96.21 21.65l2.17 3.48c-1.75-.88-23.06 10.17-26.44 11.51a92.81 92.81 0 0 1-31.41 6.89c-19.27.56-46.26-2.89-56.89-21.41-.57-1-1.08-2.02-1.53-3.07"
            fill="#18E8E3"
            fillRule="nonzero"
            stroke="#FFF"
            strokeWidth="1.5"
          />
          <path
            d="M283.86 252.66c-1.17-.94-2.55-1.67-4-.95-.47.28-.93.6-1.36.93-.56.34-1.19.55-1.84.62a2 2 0 0 0-1.4 2.46c1.31 4.94 11.74-.54 8.6-3.06z"
            fill="#9978FF"
            fillRule="nonzero"
          />
          <path
            style={{ mixBlendMode: 'multiply' }}
            d="M401.73 43.93a8 8 0 0 1-3.65-1.51 6.31 6.31 0 0 1-1.93-2.21 1.39 1.39 0 0 1 1.09-1.91c.84-.16 1.46.5 1.94 1.09A5 5 0 0 0 401 41c.65.33 1.66.25 2.16.84.65.77-.53 2.21-1.43 2.09zM408 25a.87.87 0 0 0-.9.85l-.34 9.38c-.97-.36-1.98-.62-3-.78a1 1 0 0 0-1.08.85.71.71 0 0 0 .65.84c1.37.24 2.72.63 4 1.17a.74.74 0 0 0 .68-.08 1 1 0 0 0 .44-.75l.38-10.62A.8.8 0 0 0 408 25z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <path
            d="M397.17 27.3a2.51 2.51 0 0 1 3.14.42c1.09 1.12 2.8-.59 1.71-1.71a5 5 0 0 0-6.02-.81 1.22 1.22 0 0 0 1.22 2.1h-.05zm15.29 4.39c.8-.2 1.62.16 2 .89.8 1.47 3 .16 2.24-1.3a4.38 4.38 0 0 0-4.91-2.09 1.3 1.3 0 0 0 .69 2.5h-.02z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <path
            style={{ mixBlendMode: 'multiply' }}
            d="M423.75 11.85c-1.58-3.13-5.34-2.62-8.28-3.46.9-2.22.05-4.76-2-6-3.35-2.13-6.85-.56-9.47 1.81-1.23-2-3.4-3.2-5.74-3.2-.22-.01-.44.03-.64.11-5.43 1-8.64 5.26-7.06 10.81.2.64.78 1.07 1.44 1.08 9.39-.83 19.32 10.41 28.49 6.37 2.86-1.23 4.77-4.54 3.26-7.52z"
            fill="#18E8E3"
            fillRule="nonzero"
          />
          <path
            d="M158.31 179.15c6.54 0 6.56-9.78 0-9.78s-6.56 9.78 0 9.78z"
            fill="#9978FF"
            fillRule="nonzero"
          />
          <path
            d="M634.17 177.22c-.3-4-3.86-5.7-7.64-5.29 1-.12 1.23-12.51-12.31-13.6-8.23-.65-14.62 5.42-16.28 12.68-2.12 9.25 2.19 17.75 7.21 25.25 1.74 2.6 5.43 11 4 14-.58 1.27-1.6 2.33-2 3.66-2 6 11.46 6.49 14.79 5.23a14.19 14.19 0 0 0 8.48-10.53c.71-3.73-1.76-10.77-1.93-15l-.4-9.65c3.81-.37 6.39-2.75 6.08-6.75z"
            fill="#FFF"
            fillRule="nonzero"
          />
          <path
            d="M607.66 188.6c3.4.34 6.8-.47 9.69-2.3 2.09-1.3 1.17 4.47-1.41 4.47s-5.43-.25-8.37-.52c-1.05-.1-.97-1.75.09-1.65zm6.47-11.9a1.1 1.1 0 0 1-.87.13 1 1 0 0 1-.59-.47.7.7 0 0 1-.09-.48.87.87 0 0 1 .48-.55c.58-.33 1.18-.61 1.81-.83a4.13 4.13 0 0 1 1.63-.19c.92.05 1.74.62 2.1 1.47.06.13.06.29 0 .42-.15.3-.41.53-.73.64a.93.93 0 0 1-1-.26l-.06-.06-.19-.22a.68.68 0 0 0-.52-.23 1.48 1.48 0 0 0-.37 0c-.49.1-.95.3-1.37.56l-.23.07zM599 178.05a.83.83 0 0 1 .48-.56 10 10 0 0 1 1.81-.82 4.11 4.11 0 0 1 1.63-.19c.92.05 1.73.62 2.09 1.46.06.14.06.3 0 .43-.14.3-.4.53-.72.64a.93.93 0 0 1-1-.26l-.06-.07-.19-.22a.63.63 0 0 0-.52-.22 1.48 1.48 0 0 0-.37 0 4 4 0 0 0-1.37.56l-.18.1c-.26.16-.57.2-.86.13a1 1 0 0 1-.6-.47.76.76 0 0 1-.14-.51zm12.3 5.95c-1.08.2-2.15.45-3.21.76a1 1 0 0 1-1.27-.9c0-2.83 0-5.67.08-8.5 0-1.26 2-1.33 2-.07l-.06 7.26c.64-.15 1.28-.3 1.93-.41 1.17-.26 1.76 1.6.53 1.86zm-14.55-14.56c3 3.6 16-1.47 19.18-2.95 3.18-1.48 6.53.19 9.74.93 2.43.56 1.78 1.76 4.18 1 .31-.07.6-.25.79-.5.13-.26.17-.56.13-.85-.51-7.93-8.52-12-15.63-12.49-6.76-.43-18.76 2.64-19.3 11.15-.18 1.3.14 2.63.91 3.71z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <path
            d="M691.18 254.83c-3.94-25.67-25-49.9-51-50.38-3.05 0-6.34.31-8.6 2.34-2.71 2.45-3.22 6.66-5.88 9.15-7.48 7-16.42-4.61-24.22-3.21-12.48 2.27-16.64 21.62-20.77 31.38-6.41 15.18-13.82 31.5-27.74 41.25-8.83 6.18-18 11.1-26.23 17.3-1.75 1.32 1.67 2.17 0 3.46 32.78.65 59.7-20 69.91-51.15l-1.92 40.49c-.07 1.48-.1 3.08.78 4.27.88 1.19 2.43 1.62 3.87 1.95a88.92 88.92 0 0 0 61.3-8.49c2-1.07 4-2.34 5-4.37.87-1.87.66-4 .3-6.07-1.69-9.33-6.2-19.47-1.5-27.71 9.6 7.27 12.76 20.5 11.93 32.51-.83 12.01-4.91 23.53-7 35.39-.42 2.42.09 5.93 2.55 5.9 13.4-22.27 23.16-48.24 19.24-73.94l-.02-.07z"
            fill="#18E8E3"
            fillRule="nonzero"
          />
          <path
            d="M524.87 302.71c-2.72.52-5.31-.69-8 .5-2.09.94-3.79 2.91-3.52 5.33a2.49 2.49 0 0 0 2.43 2.43c3.46-.11 6.86-.92 10-2.37a2 2 0 0 0 1.23-1.52c1.91-1.21.6-4.89-2.14-4.37zm142.82 25.74c-1.4 2.22-2.73 4.48-4 6.78-.54.95-.39 2.15.38 2.94a4.26 4.26 0 0 0 5.48.15c1.71-1.3 2-3.41 2.11-5.42.02-.42-.07-.84-.27-1.21l.48-.79c1.68-2.65-2.52-5.1-4.18-2.45z"
            fill="#FFF"
            fillRule="nonzero"
          />
          <path
            style={{ mixBlendMode: 'multiply' }}
            d="M652.21 194.38c2.15-.54 3.36-3 3.24-5.22-.49-9-10.77-15.79-18-19.31a43.66 43.66 0 0 1-6.85-3.85c-1.13-7.24-8.71-11-15.5-11.44-6.79-.44-18.76 2.64-19.3 11.15a5.16 5.16 0 0 0 .91 3.73c.36.44.83.78 1.35 1 1.86-7 8.12-12.72 16.12-12.09 13.54 1.09 13.35 13.48 12.31 13.6 3.78-.41 7.34 1.29 7.64 5.29.3 4-2.27 6.38-6.07 6.79l.4 9.65c.17 4.21 2.64 11.25 1.93 15a14.76 14.76 0 0 1-4.42 8c1.79 2.56 4.62 4.06 8.64 3.85 3.44-.17 8.91-1.31 11.35-3.85 2.13-2.21 1.16-4.44 1.31-7.19 4.1.12 10.6-.73 10.59-5.81.03-3.88-1.96-7.89-5.65-9.3z"
            fill="#6A25D6"
            fillRule="nonzero"
          />
          <path
            d="M253.23 506.2c2.39-.28 4.74-.84 7-1.66 8.9-4.18 4.1-10.47-2.63-13.56-9.1-4.18-21.41-1.57-31.11-1.36-25.21.57-50.41 1.07-75.61 1.83-18.36.55-59.73-8.3-59.73 8.25-.03 15.04 128.66 11.83 162.08 6.5zm447.97-26.07a9.36 9.36 0 0 0-2.25-1.57c-8.09-4-50.05.94-58.79.48-30.22-1.6-31.15-2.6-61.37-1.84-5.64.14-10.08 1.16-14 5.43-11 12.07 7.58 13.64 16.12 13.87 19.2.51 37.52 3.32 56.71 2.71 9.85-.3 19.69-.59 29.54-.63 8.41 0 19-2 27.28-3.36 3.34-.53 6.66-2.19 8.42-5.08a8 8 0 0 0-1.66-10.01z"
            fill="#9978FF"
            fillRule="nonzero"
            opacity=".1"
          />
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components-legacy/SVG/IllustrationWebsiteEditing.js